import weApi from '@/api/we/api_we.js'


// web map key: we key value: we data
let weMap = new Map();
let statusInterval = undefined;

let weClient = {
  /**
   * 初始化 we
   * @param key
   * @param weHandler 处理对象：封装处理函数，当后端发送消息或通道发生变更的时候将会调用对应的回调
   *                 weHandler.onMessage  后端向前端发送了消息
   *                 weHandler.onClose 通道关闭了
   */
  initWe(key, we){
    we.key = key;
    weMap.set(key, we);
    runRefreshStatusInterval();
  },
  /**
   * 销毁 we
   * @param key
   */
  close(key) {
    //客户端销毁
    weMap.delete(key);
    //服务端销毁
    weApi.close({key: key});
  }
}


/**
 * 状态刷新定时器
 */
function runRefreshStatusInterval() {
  if (statusInterval) {
    return;
  }
  statusInterval = window.setInterval(() => {
    refreshStatus();
  }, 1 * 1000)
}

/**
 * 状态刷新函数
 */
function refreshStatus() {
  //如果状态全部刷新完成将不必再进行刷新
  if (!weMap || weMap.size < 1){
    window.clearInterval(statusInterval);
    statusInterval = undefined;
    return;
  }

  let dataList = [...weMap].map(t => {
    return {
      key: t[1].key,
      version: t[1].version
    }
  })
  let params = {
    items: dataList
  };
  weApi.status(params).then(res => {
    let resItems = res.data.items;
    for (let index in resItems) {
      let keyData = resItems[index];
      let we = weMap.get(keyData.key);
      //版本变更
      keyData.version = keyData.lastVersion;

      //通道状态变更
      if (keyData.change) {
        we.onMessage(keyData.key, keyData.data);
        we.version = keyData.version;
      }

      //如果通道关闭 或者是最终状态就进行通道的销毁
      if (keyData.close || keyData.finalVersion) {
        weClient.close(keyData.key);
        return;
      }
    }
  });
}


export default weClient;



// WEBPACK FOOTER //
// ./src/common/we/weClient.js